import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const imageHeight = '88px';
const imageLeftSideHeight = '224px';
const maxImageRightSideWidth = '106px';

export const useCardHalfBackgroundLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  image: {
    height: imageHeight,
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderTopRightRadius: tokens.borderRadiusMedium,
  },
  rightSideImage: {
    height: imageLeftSideHeight,
    borderTopRightRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
    maxWidth: maxImageRightSideWidth,
  },
  topLine: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    ...shorthands.padding(
      tokens.spacingVerticalS,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalM,
    ),
  },
  topLineText: {
    display: 'flex',
    alignItems: 'center',
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorNeutralForeground3,
  },
});
